import { render } from "./ViewRatingRow.vue?vue&type=template&id=781c1876&scoped=true"
import script from "./ViewRatingRow.vue?vue&type=script&lang=js"
export * from "./ViewRatingRow.vue?vue&type=script&lang=js"

import "./ViewRatingRow.vue?vue&type=style&index=0&id=781c1876&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-781c1876"

export default script